module.exports = __webpack_public_path__ + "img/djj1.eeabbd21.png";